import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios-instance";

export const fetchProfile = createAsyncThunk(
    "profile/fetchProfile",
    async () => {
        try {
            const response = await axiosInstance({
                method: "get",
                url: "/profile",
            });

            /*  console.log('PROFILE FROM CONTROLLER')
            console.log(response.data.data)*/
            return response.data.data;
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    },
);
